import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Redirect, Route, Switch } from 'react-router-dom';
import ScrollToTop from 'components/ScrollToTop';
import { CaptchaPage } from '@piplapps/pipl-ui';
import { PageNotFound } from '@pipltrust/apps-components';
import { history } from './utils';
import AppConfig from '../config/AppConfig';
import { HTTPClientSEF } from '../services/ApiService';
import { PIPL_SERVER_SECURITY_URL_PREFIX } from '../constants/Constants';
import DailyBlock from './Search/DailyBlock';
import { LoggedRoute } from '../components/PermissionComponents/Permissons';
import PurchaseFlow from './Search/PurchaseFlow';
import Management from './Search/ManagementPanel';

const Router = () => {
  return (
    <ConnectedRouter history={history}>
      <ScrollToTop>
        <Switch>
          <Route
            path="/manage/captcha"
            component={() => (
              <CaptchaPage
                sitekey={AppConfig.RECAPTCHA_KEY}
                HTTPClient={HTTPClientSEF}
                urlPrefix={PIPL_SERVER_SECURITY_URL_PREFIX}
              />
            )}
          />
          <Route path="/daily-block" component={DailyBlock} />
          <LoggedRoute path="/manage/purchase" component={PurchaseFlow} />
          <LoggedRoute path="/manage/upgrade" component={PurchaseFlow} />
          <LoggedRoute path="/manage" component={Management} />
          <Redirect path="/search/manage" to="/manage" />
          <Route path="/*" component={PageNotFound} />
        </Switch>
      </ScrollToTop>
    </ConnectedRouter>
  );
};

export default Router;
